import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=fde1fadc&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde1fadc')) {
      api.createRecord('fde1fadc', component.options)
    } else {
      api.reload('fde1fadc', component.options)
    }
    module.hot.accept("./DataBoard.vue?vue&type=template&id=fde1fadc&", function () {
      api.rerender('fde1fadc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DataBoard.vue"
export default component.exports